<template>
  <div
    :class="bem()"
  >
    <div :class="bem('title')">
      <div
        :class="bem('logo')"
      >
        <DatoCmsImage
          :data="props.item.logo.responsiveImage"
          object-fit="cover"
          :object-position="`${props.item.logo.focalPoint.x * 100}% ${
            props.item.logo.focalPoint.y * 100
          }%`"
          layout="fill"
          sizes="(max-width: 1280px) 100vw, 40vw"
        />
      </div>
      <VisionHeading
        v-if="props.item.name"
        tag="h6"
        size="h5"
      >
        {{ props.item.name }}
      </VisionHeading>
    </div>
    <div :class="bem('main')">
      <VisionHeading
        tag="h6"
        size="h4"
        :class="bem('quote')"
      >
        {{ props.item.quote }}
      </VisionHeading>
      <p
        v-if="props.item.secondary"
        :class="bem('secondary')"
      >
        {{ props.item.secondary }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Image as DatoCmsImage } from 'vue-datocms'

const bem = useBEM('CredibilityPR')

const props = defineProps({
  item: { type: Object, required: true }
})

</script>

<style lang="postcss">
.CredibilityPR {
  @apply flex flex-col gap-6
  justify-between items-stretch
  py-6 px-5 rounded-lg
  bg-grey-200;
}

.CredibilityPR__main {
  @apply flex flex-col gap-3 pb-3;
}

.CredibilityPR__title {
  @apply flex gap-3 items-center;
}

.CredibilityPR__logo {
  @apply relative w-12 h-12 rounded-full overflow-clip;
}
</style>